import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { Question } from "types";
import type { RootState } from "../store";

// Define a type for the slice state
interface QuestionsState {
  questions: Question[];
}

// Define the initial state using that type
const initialState: QuestionsState = {
  questions: [],
};

export const questionsSlice = createSlice({
  name: "questions",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
    setGlobalQuestions: (state, action: PayloadAction<Question[]>) => {
      state.questions = action.payload;
    },
  },
});

export const { setGlobalQuestions } = questionsSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const getQuestions = (state: RootState) => state.questions;
export default questionsSlice.reducer;
